export enum JdName {
    NAME = "JD"
}
